import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Overlay, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { Formik, Form } from "formik";
import FormikControl from "../../../layouts/Input/FormikControl";
import { toast } from "react-toastify";
import { renderCell,renderHeader } from "../../../utilities/FUNCTIONS";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import axios from "../../../apis/Api";
import {
  GET_DISTRIBUTOR_DDL,
  GET_DISTRIBUTIONCENTER_DDL,
  GET_LENDER_DDL,
  GET_DELIVERYMAN_TILL_DDL,
} from "../../../Types";

import {
  getFinancingLedgerReport,
  downloadJob,
} from "./FinancingLedgerReportActions";
import Moment from "react-moment";
import storage from "../../../apis/Storage";
import { isPermittedPage } from "../../../apis/Utility";
import { formatDate } from "../../../utilities/FUNCTIONS";

const FinancingLedgerReport = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));
  //Pagination
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setDistCenterList] = useState([]);
  const [deliverymanNameList, setDeliverymanNameList] = useState([]);

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const [filter, setfilter] = useState({
    distributor: null,
    distCenter: null,
    vizId: null,
    financier: null,
    financierId: null,
    dlmTillNo: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    pageSize: 5,
    searchText: null,
    isExport: false,
  });

  const [lenderOptions, setLenderOptions] = useState([]);

  const columns = [
    {
      Header: "VIZ ID",
      accessor: "vizId",
    },
    {
      Header: "Financer ",
      accessor: "financier",
    },
    {
      Header: "Distribution Center ",
      accessor: "distCenterName",
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: (row) => (
        <div>
        {row.value ? <Moment format="DD/MM/YYYY">{row.value}</Moment> : ""}
      </div>
      ),
    },
    {
      Header: "Shop Code",
      accessor: "shopCode",
    },
    {
      Header: "Financer ID",
      accessor: "financierId",
    },
    {
      Header: "Invoice No.",
      accessor: "invoiceNo",
    },
    {
      Header: "DLM Name",
      accessor: "dlmTillName",
    },
    {
      Header: "Narration",
      accessor: "narration",
    },
    {
      Header: renderHeader("Debit"),
      accessor: "debit",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Credit"),
      accessor: "credit",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Balance"),
      accessor: "balance",
      Cell: ({ value }) => renderCell(value, true),
    },
  ];

  const openingBalanceRow = {
    vizId: '',
    financier: '',
    distCenterName: '',
    repaymentDate: '',
    shopCode: '',
    financierId: '',
    invoiceNo: '',
    dlmTillName: '',
    narration: 'Opening Balance',
    debit: '',
    credit: '',
    balance: props.FinancingLedgerReportdata?.openingBalance,
  };

  const closingBalanceRow = {
    vizId: '',
    financier: '',
    distCenterName: '',
    repaymentDate: '',
    shopCode: '',
    financierId: '',
    invoiceNo: '',
    dlmTillName: '',
    narration: 'Closing Balance',
    debit: '',
    credit: '',
    balance: props.FinancingLedgerReportdata?.closingBalance,
 
  };
  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setfilter({
      distributor:
        userRights != null && userRights?.userType == "DistributorUser"
          ? filter.distributor
          : null,
      distCenter: null,
      vizId: null,
      dlmTillNo: null,
      financier: null,
      fromDate: new Date(),
      toDate: new Date(),
      pageNo: 0,
      searchText: null,
      isExport: false,
    });
  };

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setSearchText(text);
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageSize: pageSize };
    fetchReportData(request);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    if (request.distributorId == '' || request.distributorId == null) {
      toast.error("Kindly fill the required fields to generate the report.")
      return
    } if (request.vizId == '' || request.vizId == null) {
      toast.error("Kindly fill the required fields to generate the report.")
      return
    }
    if (request.financierId == '' || request.financierId == null) {
      toast.error("Kindly fill the required fields to generate the report.")
      return
    }
    fetchReportData(request);
    setShow(false);
  };

  const Download = () => {
    let request = formRequestObject(true);
    props.downloadJob(request);
  };

  function formRequestObject(isExport = false) {
    let requestData = {
      distributorId: filter.distributor?.value,
      distCenterId: filter.distCenter?.value,
      vizId: filter.vizId,
      financierId: filter.financierId,
      financier: filter.financier?.value,
      dlmTillNo: filter.dlmTillNo?.value,
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.toDate && formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
      isExport: isExport,
    };
    if (userRights != null && userRights?.userType == "DistributorUser") {
      requestData = {
        ...requestData,
        distributorId: userRights?.distributorId,
      };
    }
    return requestData;
  }

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    props.getFinancingLedgerReport(finalRequest);
  }

  // useEffect(() => {
  //   setCurrentPageNo(0);
  //   fetchReportData();
  // }, [searchText]);

  useEffect(() => {
    if (props.FinancingLedgerReportdata) {
      setTotalRecords(props.FinancingLedgerReportdata?.totalRecords);
    } else {
      setTotalRecords(0);
    }
  }, [props.FinancingLedgerReportdata]);

  useEffect(() => {
    props.getDropdownList(`api/Lender/GetLendersDDL`, GET_LENDER_DDL);
  }, []);

  useEffect(() => {
    setLenderOptions(
      props.allLenderList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.allLenderList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId
      );
      if (distributorList?.length > 0) {
        setfilter({
          ...filter,
          distributor: {
            label: distributorList[0]?.label,
            value: distributorList[0]?.value,
          },
        });
      }
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distCenterList = props.selectedDistCentersList.filter((x) =>
        userRights?.distCenterIds.includes(x.value)
      );
      setDistCenterList(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setDistCenterList(
        props.selectedDistCentersList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.selectedDistCentersList]);

  useEffect(() => {
    if (props.deliverymanTills) {
      setDeliverymanNameList(
        props.deliverymanTills.map(function (item) {
          return {
            value: item.qrCode,
            label: item.fullname,
          };
        })
      );
    }
  }, [props.deliverymanTills]);

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
  }, []);

  useEffect(() => {
    if (filter.distributor) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        {distributorIds: filter.distributor.value},
        GET_DISTRIBUTIONCENTER_DDL
      );
    }
    filter.distCenter = null;
    filter.deliverymanName = null;
  }, [filter.distributor]);

  useEffect(() => {
    if (filter.distCenter) {
      props.getDropdownList(
        `api/DistCenter/GetCenterDeliveryUserDDL/${filter.distCenter.value}`,
        GET_DELIVERYMAN_TILL_DDL
      );
    }
    filter.deliverymanName = null;
  }, [filter.distCenter]);

  return (
    <div>
      <VzPageContainer title="Financing Ledger Report">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Financing Ledger Report</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={{}}
                      validator={() => ({})}
                      onSubmit={(e) => LoadDataByfilter(e)}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            {userRights == null && (
                              <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="Distributor Name"
                                  name="distributor"
                                  options={distributorList}
                                  isClearable={true}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    if (!e || !e.value) {
                                      setfilter({
                                        ...filter,
                                        distributor: null,
                                      });
                                      return;
                                    }
                                    setfilter({
                                      ...filter,
                                      distributor: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                  value={filter.distributor}
                                />
                              </Col>
                            )}

                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distribution Center*"
                                name="distCenter"
                                options={
                                  filter.distributor != null
                                    ? distCenterList
                                    : []
                                }
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      distCenter: null,
                                    });
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    distCenter: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.distCenter}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Deliveryman Name*"
                                name="deliverymanName"
                                options={
                                  filter.distCenter != null
                                    ? deliverymanNameList
                                    : []
                                }
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      dlmTillNo: null,
                                    });
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    dlmTillNo: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.dlmTillNo}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="Viz ID*"
                                name="vizId"
                                handleOnChange={(e) => {
                                  filter.vizId = e;
                                  setfilter({ ...filter, vizId: e });
                                }}
                                value={filter.vizId}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Lender*"
                                name="financier"
                                options={lenderOptions}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    financier: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.financier}
                              />
                            </Col>
                             <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="Financer ID*"
                                name="FinancerId"
                                handleOnChange={(e) => {
                                  filter.financierId = e;
                                  setfilter({ ...filter, financierId: e });
                                }}
                                value={filter.financierId}
                              />
                            </Col>
                            <Row style={{ paddingRight: 0 }}>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  control="date"
                                  label="From Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, fromDate: value });
                                  }}
                                  value={filter.fromDate}
                                />
                              </Col>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  control="date"
                                  label="To Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, toDate: value });
                                  }}
                                  value={filter.toDate}
                                />
                              </Col>
                            </Row>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
          {isPermittedPage("Export", props.actions, props.userRole) && (
            <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={Download}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-download me-1" />
                Export
              </Button>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
          {/* <CustomDataTable
               data={props.FinancingLedgerReportdata?.report ?? []}
               columns={columns}
              getTrProps={(event, data) => null}
              IsPagingEnable={false}
            /> */}
            { <ServerSideDataTable
              data={props.FinancingLedgerReportdata?.report ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            /> }
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    selectedDistCentersList: state.ddlList.selectedDistCentersList
      ? state.ddlList.selectedDistCentersList
      : [],
    deliverymanTills: state.ddlList.deliverymanTills
      ? state.ddlList.deliverymanTills
      : [],
    allLenderList: state.ddlList.lenderList ? state.ddlList.lenderList : [],
    FinancingLedgerReportdata: state.FinancingLedgerReportList,
  };
};

export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost,
  getFinancingLedgerReport,
  downloadJob,
})(FinancingLedgerReport);
